import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
// import { withRouter } from "react-router-dom"
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import SidebarContent1 from "./SidebarContent1";

const Sidebar = props => {
  const data  =  localStorage.getItem("dashboardName")
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {/* {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent1 />} */}
          {
 
            (data === "cables-r-us") ? <SidebarContent /> : <SidebarContent1 />
          }
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
